export default __webpack_public_path__ + "static/media/homeslider2.54f765a6.jpg";